export const SIGN_UP = '/signup';
// export const MAIN = '/';
export const SIGN_IN = '/';
export const PASSWORD_FORGET = '/pw-forget';
export const ADMIN ="/admin";
export const HOME = '/home';
export const ACCOUNT = '/account';
export const VENDORHISTORY = '/history';
export const UPLOADUSER = '/upload-user';
export const FORMUPLOAD = "/formupload";
export const CHATADMIN = "/chat-admin";
export const CHATUSER = "/chat-user";
export const HEADER = '/header';